import { ReactElement, useEffect } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useFeatures from "./useFeatures";
import useGA from "../../_common/modules/fe-modules/GA/useGA";
import {
  GaEvent,
  GA_FEATURES_DESIGN,
  GA_TOYOTA_FOR_YOU_OVERLAY,
  GA_TOYOTA_FOR_YOU_OVERLAY_PAGE,
} from "../../_common/modules/fe-modules/GA/static";

import "./_Features.scss";

const Features = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useFeatures();
  const { triggerGAEvent } = useGA();

  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  useEffect(() => {
    triggerGAEvent(GaEvent.VIEW_SCREEN, {
      event: GA_TOYOTA_FOR_YOU_OVERLAY,
      viewName: GA_TOYOTA_FOR_YOU_OVERLAY_PAGE,
      viewSection: GA_FEATURES_DESIGN,
    });
  }, [triggerGAEvent]);

  return (
    <div className="Features">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Features;
